import { useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { TripQueryFilter } from '../../shared/types';
import { CITRIN_GET_TRIPS, GetTripsRequest, GetTripsResponse } from '..';

export const useGetTripsQuery = (request: TripQueryFilter, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: TripQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetTripsResponse, GetTripsRequest>(CITRIN_GET_TRIPS, {
        variables: { request: internalRequest },
        // fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Trips', data),
    });

    return { ...rest, previousData: previousData?.CITRIN_MGT_getTrips, data: data?.CITRIN_MGT_getTrips ?? [] };
};
